import { Form, Formik } from "formik";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import * as yup from "yup";
import FormikTextField from "../../components/Forms/FormikTextField";
import { Constants } from "../../libs/Constants";
import { update } from "../../libs/dbFunctions";
import useEmployeeContext from "./contexts/useEmployeeContext";
const schema = yup.object({
  amount1: yup
    .number()
    .required("Amount 1 is required.")
    .moreThan(0, "Amount should be greater than 0"),
  amount2: yup
    .number()
    .required("Amount 2 is required.")
    .moreThan(0, "Amount should be greater than 0"),
});
export const VerifyBankAccount = () => {
  const { employee, refreshEmployee } = useEmployeeContext();
  const [showVerifyAccount, setShowVerifyAccount] = React.useState(false);

  const handleVerifyAccount = async (values, { setSubmitting }) => {
    setSubmitting(true);

    let saveFields = {
      id: employee.id,
      account_id: employee.accounts.find(
        (account) => account.status === "unverified"
      ).id,
      amount1: values.amount1,
      amount2: values.amount2,
      companyId: employee.companyId,
    };
    //verify the account
    try {
      await update(Constants.dbTypes.ACCOUNT, saveFields, employee.companyId);
      toast.info(
        "Verification is in progress. It may take 2-3 days to complete the process."
      );
      refreshEmployee();
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        toast.error(e.response.data.error);
      } else {
        toast.error(e);
      }
    }
    setSubmitting(false);
    setShowVerifyAccount(false);
  };

  const renderVerifyModal = () => {
    return (
      <Modal
        show={showVerifyAccount}
        onHide={() => setShowVerifyAccount(false)}
        size="md"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="contribution-modal font-secondary"
      >
        <Modal.Header className="p-4" closeButton>
          <Modal.Title>Verify Account</Modal.Title>
        </Modal.Header>
        <Formik
          onSubmit={handleVerifyAccount}
          initialValues={{ amount1: "", amount2: "" }}
          validationSchema={schema}
        >
          {({ isValid, isSubmitting }) => (
            <Form className="w-100">
              <Modal.Body>
                <FormikTextField
                  size="lg"
                  controlId="amount1"
                  label="Amount 1"
                  name="amount1"
                  type="number"
                  className="mb-4"
                />
                <FormikTextField
                  size="lg"
                  controlId="amount2"
                  label="Amount 2"
                  name="amount2"
                  type="number"
                  className="mb-4"
                />
              </Modal.Body>
              <Modal.Footer>
                <Button
                  type="submit"
                  className="btn btn-primary"
                  disabled={!isValid || isSubmitting}
                >
                  Submit
                </Button>
                <Button
                  type="button"
                  variant="outline-cancel"
                  onClick={() => setShowVerifyAccount(false)}
                >
                  Cancel
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    );
  };

  return (
    <>
      <Button
        onClick={() => {
          setShowVerifyAccount(true);
        }}
      >
        Verify Account
      </Button>
      {showVerifyAccount && renderVerifyModal()}
    </>
  );
};
